import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

export const MoveToPhaseModalSkeleton = () => {
  return (
    <Box component="ul" gap="s16">
      {[...Array(6)].map((_, index) => (
        <Box component="li" gap="s8" flexDirection="row" alignItems="center" key={index}>
          <Skeleton height="s16" width="s16" />
          <Skeleton height="s24" width="s200" />
        </Box>
      ))}
    </Box>
  )
}
